define('drops/multiSelect/dropdownitem',[
    'jquery',
    'underscore',
    'lq/dynamicContentImage'
], function ($, _, dynamicContentImage) {
    'use strict';

    var DropDownItem = function (
            list,
            id,
            label,
            checked) {
        this.list = list;

        this.id = id;
        this.label = label;
        this.checked = !!checked;

        this.$checkbox = $('<input type = "checkbox" />')
            .addClass('userstyle-' + list.drop.data.styles)
            .prop('checked', this.checked)
            .on('change', this.onCheckboxToggled.bind(this));

        var $checkboxWrapper = $('<label class="checkbox-wrapper" />')
            .css("position", "relative")
            .append(this.$checkbox)
            .append($('<div class="custom-icon" />').css("display", "none"));

        this.$element = $('<tr />')
            .addClass('tableData')
            .append($('<td />')
                .append($checkboxWrapper));
    };

    DropDownItem.prototype.setReadOnly = function () {
        this.$checkbox.prop('disabled', true);
    };

    DropDownItem.prototype.addExtraColumns = function (values) {
        this.$element
            .append(_.map(values, this.createExtraColumn.bind(this)));
    };

    DropDownItem.prototype.createExtraColumn = function(value) {
        if (value !== null && value !== undefined && (value.type === 'LicquidDocumentVersionDetail' || value.columnName === this.list.drop.data.iconColumn)) {
            var imgUrl = '';
            if (value.type === 'LicquidDocumentVersionDetail' && value.content?.Url) {
                var url = dynamicContentImage.getPath({
                    imageName: value.content.Url,
                        useThumbnail: true,
                        resizeOption: 'fillKeepRatio',
                        thumbnailFileType: 'png'
                });
                imgUrl = 'url(' + url + ')';
            } else if (value.content) {
                imgUrl = 'url(' + value.content + ')';
            }
            return $('<td />')
                .append($('<div class = "icon" />')
                    .css({
                        backgroundImage: imgUrl
                    }))
                .on('click', this.onRowClicked.bind(this));
        } else if (value !== null && value !== undefined) {
            return $('<td />')
                .text(value.content)
                .on('click', this.onRowClicked.bind(this));
        }
        return $('<td />')
            .text(value)
            .on('click', this.onRowClicked.bind(this));
    };

    DropDownItem.prototype.onCheckboxToggled = function () {
        this.toggle();
        this.updated();
        this.triggerEvents();
    };

    DropDownItem.prototype.onRowClicked = function () {
        this.toggle();
        this.updated();
        this.triggerEvents();
    };

    DropDownItem.prototype.triggerEvents = function () {
        this.list.triggerEventIfEnabled('changed');

        if (this.checked)
            this.list.triggerEventIfEnabled('itemSelected', this.id);
        else
            this.list.triggerEventIfEnabled('itemDeselected', this.id);
    };

    DropDownItem.prototype.updated = function () {
        this.checked = this.$checkbox.is(":checked");

        this.list.updateSummary();
        this.list.updateRequiredIndicator();
    };

    DropDownItem.prototype.toggle = function () {
        if (this.checked)
            this.uncheck();
        else
            this.check();
    };

    DropDownItem.prototype.uncheck = function () {
        this.$element.removeClass('selected');
        this.$checkbox.prop('checked', false);
        this.updated();
    };

    DropDownItem.prototype.check = function () {
        this.$element.addClass('selected');
        this.$checkbox.prop('checked', true);
        this.updated();
    };

    return DropDownItem;
});
